
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center" v-if="!showAccos&&!showHosts">Price improvement {{ prip.prip_nr }}</v-card-title>
            <v-card-title class="justify-center" v-if="showAccos||showHosts">Price improvement <span>{{ prip.prip_nr }}</span> overview {{ title }}</v-card-title>
            <v-divider/>
            <v-card-text  v-if="!showAccos&&!showHosts">
                <v-row dense class="pa-2">
                    <v-col cols="4">Description</v-col>
                    <v-col cols="8">{{ prip.prip_oms }}</v-col>
                    <v-col cols="4">Type</v-col>
                    <v-col cols="8">{{ prip.prip_type }}</v-col>
                    <v-col cols="4">Email send</v-col>
                    <v-col cols="8">{{ prip.prip_mail_dt }}</v-col>
                    <v-col cols="4">Change until (inclusive)</v-col>
                    <v-col cols="8">{{ prip.prip_wijzig_tm_dat }}</v-col>
                </v-row>
                <v-divider/>
                <v-row dense class="pa-2">
                    <v-col cols="4">Accommodations</v-col>
                    <v-col cols="6">{{ prip.accos }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showAccoList('All', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportAccoList('All')">Export</v-btn></v-col>
                    <v-col cols="4">Accommodations opt-in set</v-col>
                    <v-col cols="6">{{ prip.accos_optin }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showAccoList('Opt-in', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportAccoList('Opt-in')">Export</v-btn></v-col>
                    <v-col cols="4">Accommodations opt-out set</v-col>
                    <v-col cols="6">{{ prip.accos_optout }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showAccoList('Opt-out', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportAccoList('Opt-out')">Export</v-btn></v-col>
                    <v-col cols="4">Accommodations no response</v-col>
                    <v-col cols="6">{{ prip.accos_no_response }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showAccoList('NoResponse', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportAccoList('NoResponse')">Export</v-btn></v-col>
                    <v-col cols="4">Accommodations selected</v-col>
                    <v-col cols="6">{{ prip.accos_selected }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showAccoList('Selected', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportAccoList('Selected')">Export</v-btn></v-col>
                </v-row>
                <v-divider/>
                <v-row dense class="pa-2">
                    <v-col cols="4">Hosts</v-col>
                    <v-col cols="6">{{ prip.eigns }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showHostList('All', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportHostList('All')">Export</v-btn></v-col>
                    <v-col cols="4">Hosts responded</v-col>
                    <v-col cols="6">{{ prip.eigns_response }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showHostList('Responded', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportHostList('Responded')">Export</v-btn></v-col>
                    <v-col cols="4">Hosts no response</v-col>
                    <v-col cols="6">{{ prip.eigns_no_response }}</v-col>
                    <v-col cols="1"><v-btn small color="primary" @click="showHostList('NoResponse', true)">View</v-btn></v-col>
                    <v-col cols="1"><v-btn small color="success" @click="exportHostList('NoResponse')">Export</v-btn></v-col>
                </v-row>
                <v-divider/>
            </v-card-text>            
            <v-card-text v-if="showAccos">
                <v-row dense class="pa-1 mr-3 font-weight-bold">
                    <v-col cols="2">Code</v-col>
                    <v-col cols="3">Name</v-col>
                    <v-col cols="3">Opt-in</v-col>
                    <v-col cols="3">Opt-out</v-col>
                    <v-col cols="1">Select</v-col>
                </v-row>
                <v-divider/>
                <div class="scrollAccos">
                    <v-row dense class="pa-1" v-for="item in selectedAccos" :key="item.acco_code">
                        <v-col cols="2">{{ item.acco_code}}</v-col>
                        <v-col cols="3">{{ item.acco_naam }}</v-col>
                        <v-col cols="3">{{ item.acco_opt_in}}</v-col>
                        <v-col cols="3">{{ item.acco_opt_out }}</v-col>
                        <v-col cols="1">
                            <v-icon v-if="item.acco_selected" color="success">mdi-check</v-icon>
                            <v-icon v-else color="error">mdi-window-close</v-icon>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-text v-if="showHosts">
                <v-row dense class="pa-1 mr-3 font-weight-bold">
                    <v-col cols="2">Code</v-col>
                    <v-col cols="7">Name</v-col>
                    <v-col cols="3">Responded</v-col>
                </v-row>
                <v-divider/>
                <div class="scrollAccos">
                    <v-row dense class="pa-1" v-for="item in selectedEigns" :key="item.eign_code">
                        <v-col cols="2">{{ item.eign_code}}</v-col>
                        <v-col cols="7">{{ item.eign_naam }}</v-col>
                        <v-col cols="3">
                            <v-icon v-if="item.eign_responded" color="success">mdi-check</v-icon>
                            <v-icon v-else color="error">mdi-window-close</v-icon>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click="showAccos = false; showHosts = false" v-if="showAccos||showHosts">Back</v-btn>
                <v-btn color="primary" @click="closeNewPrip" v-if="!showAccos&&!showHosts">Close</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                datmenu: false,
                title: "",
                hulpDate: "",
                showAccos: false,
                showHosts: false,
                selectedAccos: [],
                selectedEigns: [],
                prip : {
                    prip_nr: 0,
                    prip_oms: "",
                    prip_type: "",
                    prip_mail_dt: "",
                    prip_wijzig_tm_dat: "",
                    accos: 0,
                    accos_optin: 0,
                    accos_optout: 0,
                    accos_no_response: 0,
                    accos_selected: 0,
                    eigns: 0,
                    eigns_response: 0,
                    eigns_no_response: 0,
                    prip_accos: [],
                    prip_eigns: [],
                }
            }  
        },
        methods: {
            openViewPrip(prip_nr) {
                this.$axios.post("ares/json/ares/syst/prip/getPripToView.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPripToView"
                    },
                    getPripToView: {
                        prip_nr: prip_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.prip =  res.data.getPripToView
                        this.dialog = true
                    }
                });
            },
            showAccoList(typeList, show) {
                this.selectedAccos = []

                if (typeList === "All") {
                    this.selectedAccos = this.prip.prip_accos,
                    this.title = "all accommodations"
                }

                if (typeList === "Opt-in") {
                    for (let iIndex=0; iIndex<this.prip.prip_accos.length;iIndex++) {
                        if (this.prip.prip_accos[iIndex].acco_opt_in > "") {
                            this.selectedAccos.push(this.prip.prip_accos[iIndex])
                        }
                    }
                    this.title = "all opt ins"
                }

                if (typeList === "Opt-out") {
                    for (let iIndex=0; iIndex<this.prip.prip_accos.length;iIndex++) {
                        if (this.prip.prip_accos[iIndex].acco_opt_out > "") {
                            this.selectedAccos.push(this.prip.prip_accos[iIndex])
                        }
                    }
                    this.title = "all opt outs"
                }

                if (typeList === "NoResponse") {
                    for (let iIndex=0; iIndex<this.prip.prip_accos.length;iIndex++) {
                        if ((this.prip.prip_accos[iIndex].acco_opt_in === "") && (this.prip.prip_accos[iIndex].acco_opt_out === "")) {
                            this.selectedAccos.push(this.prip.prip_accos[iIndex])
                        }
                    }
                    this.title = "not yet responded"
                }
                if (typeList === "Selected") {
                    for (let iIndex=0; iIndex<this.prip.prip_accos.length;iIndex++) {
                        if (this.prip.prip_accos[iIndex].acco_selected) {
                            this.selectedAccos.push(this.prip.prip_accos[iIndex])
                        }
                    }
                    this.title = "will be selected"
                }

                this.showAccos = show
            },
            showHostList(typeList, show) {
                this.selectedEigns = []

                if (typeList === "All") {
                    this.selectedEigns = this.prip.prip_eigns
                    this.title = "all hosts"
                }

                if (typeList === "Responded") {
                    for (let iIndex=0; iIndex<this.prip.prip_eigns.length;iIndex++) {
                        if (this.prip.prip_eigns[iIndex].eign_responded) {
                            this.selectedEigns.push(this.prip.prip_eigns[iIndex])
                        }
                    }
                    this.title = "hosts that have responded"
                }

                if (typeList === "NoResponse") {
                    for (let iIndex=0; iIndex<this.prip.prip_eigns.length;iIndex++) {
                        if (!this.prip.prip_eigns[iIndex].eign_responded) {
                            this.selectedEigns.push(this.prip.prip_eigns[iIndex])
                        }
                    }
                    this.title = "hosts that have not responded"
                }


                this.showHosts = show
            },
            exportAccoList(typeList) {
                this.showAccoList(typeList, false)
                let acco_array=[];

                for(let index = 0; index < this.selectedAccos.length; index++) {
                        
                    let acco = new Object();

                    acco["Accommodation"]=this.selectedAccos[index].acco_code;
                    acco["Name"]=this.selectedAccos[index].acco_naam;
                    acco["Opt-in"]=this.selectedAccos[index].acco_opt_in;
                    acco["Opt-out"]=this.selectedAccos[index].acco_opt_out;
                    acco["Selected"]=this.selectedAccos[index].acc0_selected;

                    acco_array.push(acco);
                }

                var XLSX = require("xlsx");
                var ws = XLSX.utils.json_to_sheet(acco_array);
                var wb = XLSX.utils.book_new();
                
                XLSX.utils.book_append_sheet(wb, ws, this.title);
                XLSX.writeFile(wb, this.title + ".xlsx");
            },
            exportHostList(typeList) {
                this.showHostList(typeList, false)
                let eign_array=[];

                for(let index = 0; index < this.selectedEigns.length; index++) {
                        
                    let eign = new Object();

                    eign["Accommodation"]=this.selectedEigns[index].eign_code;
                    eign["Name"]=this.selectedEigns[index].eign_naam;
                    eign["Has responded"]=this.selectedEigns[index].eign_responded;

                    eign_array.push(eign);
                }

                var XLSX = require("xlsx");
                var ws = XLSX.utils.json_to_sheet(eign_array);
                var wb = XLSX.utils.book_new();
                
                XLSX.utils.book_append_sheet(wb, ws, this.title);
                XLSX.writeFile(wb, this.title + ".xlsx");
            },
            closeNewPrip() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
    .scrollAccos {
        max-height: 400px;
        height: 400px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>